export const styles = {
    fontSize: { tablet: 'sm', base: 'xs' },
    display: 'flex',
    alignItems: 'center',
    padding: { tablet: '3', base: '2' },
    lineHeight: '.85',
    borderColor: 'accent',
    fontWeight: 'medium',
    borderRadius: '0.375rem',
    backgroundColor: 'inherit',
    color: 'text.primary',
    gap: 1,
    height: '40px',
};
